import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const images = [
  { src: "/assets/slider/a1.jpeg", text: "Welcome to Yuvraj Mehendi!" },
  { src: "/assets/slider/a2.jpeg", text: "Full handi Mehendi design!" },
  { src: "/assets/slider/a3.jpeg", text: "Bridal Mehendi" },
  { src: "/assets/slider/a4.jpeg", text: "Good Looking Design" },
  { src: "/assets/slider/a5.jpeg", text: "Dulha Dulhan Mehandi" },
  { src: "/assets/slider/a6.jpeg", text: "Custom Mehendi Design" },
  { src: "/assets/slider/a7.jpeg", text: "Professional Mehendi design!" },
];

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full h-[50vh] lg:h-screen overflow-hidden">
      <div className="relative w-full h-full">
        <img
          src={images[currentIndex].src}
          alt={images[currentIndex].text}
          className="w-full h-full object-cover opacity-70"
        />
        <div className="w-full absolute top-1/4 left-1/2 transform -translate-x-1/2 text-white font-bold z-10">
          <h1 className="text-center text-4xl md:text-6xl sm:text-2xl">
            {images[currentIndex].text}
          </h1>
          <p className="text-center text-2xl mt-4">
            Book Your Mehendi Design Now
          </p>
          <div className="flex items-center justify-center mt-8">
            <button className="p-4 px-6 text-lg bg-yellow-500 hover:bg-yellow-600 rounded-full">
              <Link to="/book-today">Book Now</Link>
            </button>
          </div>
        </div>
        <button
          onClick={prevSlide}
          className="absolute top-1/2 left-4 transform -translate-y-1/2 text-white text-3xl md:text-5xl bg-black bg-opacity-50 rounded-full p-6 hover:bg-opacity-80 z-20"
        >
          &#10094;
        </button>
        <button
          onClick={nextSlide}
          className="absolute top-1/2 right-4 transform -translate-y-1/2 text-white text-3xl md:text-5xl bg-black bg-opacity-50 rounded-full p-6 hover:bg-opacity-80 z-20"
        >
          &#10095;
        </button>
      </div>
    </div>
  );
};

export default Hero;
